<template>
  <el-row>
    <el-col>
      <Filters
        class="mb-3"
        :resource="$sdk.account_address"
        :filters.sync="filters"
        @apply="$refs.table.loadTable()"
        @ready="$refs.table.loadTable()"
      />

      <el-card shadow="never">
        <AddressesTable
          ref="table"
          :account-id="accountId"
          :filters="filters"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import AddressesTable from '@/components/Application/CustomerService/Accounts/Account/Addresses/AddressesTable'
import Filters from '@/components/Filters/Complex'
import Filter, { IS } from '@/plugins/sdk/Filter'

export default {
  components: {
    AddressesTable,
    Filters
  },
  props: {
    accountId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      breadcrumb: {
        name: 'Addresses',
        route: { name: 'customerservice-accounts-account-addresses', params: { accountId: this.$route.params.accountId } }
      },
      actions: [],
      filters: [
        new Filter('account', IS, this.accountId, true, true)
      ]
    }
  },
  mounted () {
    this.actions = this.$refs.table.actions
  }
}
</script>
